/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2019-11-14.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2019-11-14.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2019-11-14.mdx';

const metadata = {
  slug: "2019-11-14",
  title: "Day in the Life of a Software Engineer",
  author: "Christian Battaglia",
  description: "A full play-by-play of a single workday as a senior software engineer at Amplify — from morning emails to standup, OAuth2 debugging, Rust services, and the reality of juggling multiple codebases.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-11-14T00:00:00.000Z",
  
  readTime: "7 min read",
  tags: ["Amplify","day in the life","software engineering","React","Rust","Actix","NGINX","OAuth2","NYC"],
};

export const Route = createFileRoute('/blog/posts/2019-11-14')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2019-11-14',
    image: '/og/blog/2019-11-14.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
